module.exports = __webpack_public_path__ + "img/f-marca-agua.f12d0c43.png";